import { ErrorBoundary } from "@sentry/react";
import { FC, ReactNode } from "react";
import { AppLayout, RequirePermission } from "../components";
import Permissions from "../constants/permissions";
import { AppError } from "../pages/static/AppError";

interface PrivateRouteProps {
  element: ReactNode;
  title: PageTitle;
  permission?: Permissions;
}

export const PrivateAccountRoute: FC<PrivateRouteProps> = ({ title, element, permission }) => (
  <RequirePermission permission={permission}>
    <AppLayout title={title}>
      <ErrorBoundary fallback={<AppError />}>{element}</ErrorBoundary>
    </AppLayout>
  </RequirePermission>
);

export const PrivateGlobalRoute = ({ title, permission, element }: PrivateRouteProps) => {
  return (
    <RequirePermission permission={permission}>
      <AppLayout title={title}>{element}</AppLayout>
    </RequirePermission>
  );
};
